import { createContext, useContext } from "react";

export interface SidebarContextValue {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

// Default is a no-op so components rendered outside PageWithLayout (e.g. the
// full-screen template editor) don't crash when calling these.
export const SidebarContext = createContext<SidebarContextValue>({
  collapsed: false,
  setCollapsed: () => {},
});

export const useSidebar = (): SidebarContextValue => useContext(SidebarContext);
